import { Chip, ChipProps } from '@mui/material';
import { AvatarCurrency } from '../Avatar/AvatarCurrency';
import { UiVault } from '../../types';
import { useTranslation } from 'react-i18next';

export type VaultChipProps = ChipProps<'div', { vault: UiVault }>;

export function VaultChip({ vault, ...props }: VaultChipProps) {
  const { t } = useTranslation();

  return (
    <Chip
      {...props}
      avatar={<AvatarCurrency currency={vault.balance.currency} />}
      label={t('Vault {{currency}}', { currency: vault.balance.currency })}
    />
  );
}
